import { render } from "./SuggestLogin.vue?vue&type=template&id=39e60374&scoped=true"
import script from "./SuggestLogin.vue?vue&type=script&lang=js"
export * from "./SuggestLogin.vue?vue&type=script&lang=js"

import "./SuggestLogin.vue?vue&type=style&index=0&id=39e60374&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e60374"]])

export default __exports__